<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import JSON from '../assets/home/yunnan.json';

    export default {
        name: 'mapChartsVisual',
        props: {
            'list': Array
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                option: {
                    tooltip: {
                        trigger: 'item',
                        triggerOn: 'mousemove',
                        formatter: params => {
                            return `${params.data.name}  ${params.data.value}分`;
                        }
                    },
                    visualMap: {},
                    series: [{
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        aspectScale: 1,
                        itemStyle: {
                            normal: { label: { show: false } },
                            emphasis: { label: { show: false } }
                        },
                        data: []
                    }]
                }
            };
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        watch: {
            list: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            getSeriesData () {
                // 填入省份及数据
                if (this.list.length > 0) {
                    return this.list.map(item => {
                        return {
                            name: item.name,
                            value: item.value
                        };
                    });
                } else {
                    return JSON.features.map(item => {
                        return {
                            name: item.properties.name,
                            value: Math.ceil(Math.random() * 100)
                        };
                    });
                }
            },
            setSeriesData () {
                this.setOptions('series', (() => {
                    return {
                        name: '重点关注总量',
                        type: 'map',
                        mapType: 'yunnan', // 自定义扩展图表类型
                        aspectScale: 1,
                        itemStyle: {
                            normal: { label: { show: false } },
                            emphasis: { label: { show: false } }
                        },
                        zoom: 1,
                        data: this.getSeriesData()
                    }
                })());
                this.setOptions('visualMap', (() => {
                    return {
                        min: 0,
                        max: 10,
                        text:['10','0'],
                        orient: 'horizontal',
                        bottom: 'bottom',
                        left: 'center',
                        right: 'center',
                        itemHeight: '100',
                        itemWidth: '10',
                        inRange: {
                            color: ['rgba(54,179,116,0.1)', 'rgba(54,179,116,1)']
                        }
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    .o-echarts {
        width: 100%;
        height: 80%;
    }
    .tips{
        display: flex;
        margin-top: 15px;
        justify-content: space-around;
        align-items: center;
        .tip-box{
            display: flex;
            align-items: center;
            .color{
                width:7px;
                height:7px;
            }
            .text{
                font-size:10px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:10px;
                margin-left: 4px;
            }
        }
    }
}
</style>
